/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Origin } from './';
import {
    OriginFromJSON,
    OriginFromJSONTyped,
    OriginToJSON,
} from './';

/**
 * 
 * @export
 * @interface CategoryWithOrigin
 */
export interface CategoryWithOrigin {
    /**
     * 
     * @type {string}
     * @memberof CategoryWithOrigin
     */
    value: string;
    /**
     * 
     * @type {Origin}
     * @memberof CategoryWithOrigin
     */
    origin: Origin;
}

/**
 * Check if a given object implements the CategoryWithOrigin interface.
 */
export function instanceOfCategoryWithOrigin(value: object): value is CategoryWithOrigin {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('origin' in value) || value['origin'] === undefined) return false;
    return true;
}

export function CategoryWithOriginFromJSON(json: any): CategoryWithOrigin {
    return CategoryWithOriginFromJSONTyped(json, false);
}

export function CategoryWithOriginFromJSONTyped(json: any, ignoreDiscriminator: boolean): CategoryWithOrigin {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'origin': OriginFromJSON(json['origin']),
    };
}

export function CategoryWithOriginToJSON(value?: CategoryWithOrigin | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'value': value['value'],
        'origin': OriginToJSON(value['origin']),
    };
}

